angular.module 'zc.projects'

.factory 'BaseProjectCrudEditor', ->
  class BaseProjectCrudEditor
    constructor: (@Resource, @Meta, @templateUrl) ->

    getNewItem: () ->
      {}

    baseLink: (scope, elem, attrs) =>
      scope.items = []
      scope.newItem = @getNewItem()

      @Resource.all(scope.projectId).then (res) ->
        scope.items = res

      scope.add = =>
        @Resource.create({projectId: scope.projectId}, scope.newItem)
        .then (res) =>
          scope.items.push res
          scope.newItem = @getNewItem()

      scope.remove = (id) =>
        @Resource.delete(scope.projectId, id)
        .then (res) ->
          scope.items = _.reject(scope.items, (pe) -> pe.id == id)

    createDirective: (extScope = {}) ->
      scope = _.assignIn {projectId: '='}, extScope
      return {
        restrict: 'E'
        require: '?projectId'
        scope
        templateUrl: @templateUrl

        link: (scope, elem, attrs) =>
          @baseLink(scope, elem, attrs)
          @link(scope, elem, attrs) if @link
      }



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.settings/base_project_crud_editor.coffee